import {ExportMarkdownDialog as CommonExportMarkdownDialog, getMarkdownFilename} from '@dv5/components'
import {DvCanvas, getCanvasContents, useAppSelector} from '@dv5/domain'
import {FC} from 'react'
import {exportCanvasToMarkdown} from '../services/markdownExportService'

interface Props {
    canvas: DvCanvas
    onClose: () => void
}

export const ExportMarkdownDialog: FC<Props> = ({canvas, onClose}) => {
    const canvasContents = useAppSelector(getCanvasContents)
    const content = canvasContents[canvas.id]
    const markdown = exportCanvasToMarkdown(canvas, content?.widgets || [], content?.widgetLinks || [])

    return (
        <CommonExportMarkdownDialog
            markdown={markdown}
            filename={getMarkdownFilename(canvas.title, 'canvas')}
            onClose={onClose}
        />
    )
}
